// import React from "react";
// // import "bootstrap/dist/css/bootstrap.min.css";
// import { useNavigate } from "react-router-dom";

// const ExitSlip = () => {
//     const navigate = useNavigate();

//   return (
//     <div className="min-vh-100 d-flex align-items-center justify-content-center bg-cream">
//       <div className="container my-5">
//         <div className="card shadow text-center">
//           <h4 className="card-header fs-3 fw-semibold bg-skyBlue text-white">
//             Exit Summary
//           </h4>

//           <div className="card-body bg-pink">
//             {/* Name and Time */}
//             <div className="mb-4">
//               <h5>
//                 <strong>Name:</strong> Sonu
//               </h5>
//               <h6 className="text-muted">
//                 <strong>Exit Time:</strong> 4:30 PM
//               </h6>
//             </div>

//             {/* User Image */}
//             <div className="mb-4">
//               <img
//                 src="https://images.unsplash.com/photo-1633332755192-727a05c4013d?w=600"
//                 alt="User Exit"
//                 className="rounded-circle shadow"
//                 style={{
//                   width: "200px",
//                   height: "200px",
//                   objectFit: "cover",
//                   border: "3px solid #c21858",
//                 }}
//               />
//             </div>

//             {/* GPS and Time Row */}
//             <div className="d-flex justify-content-around mb-4">
//               <div>
//                 <strong>GPS:</strong> 26.85°N, 80.94°E
//               </div>
//               {/* <div>
//                 <strong>Time:</strong> 4:30 PM
//               </div> */}
//             </div>

//             {/* OK Button */}
//             <div>
//               <button
//                 className="btn btn-primary px-4 fw-semibold"
//                 onClick={() => navigate("/kitchen")}
//               >
//                 OK
//               </button>
//             </div>
//           </div>

//           <div className="card-footer text-muted small">Indev Consultancy ©2025</div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ExitSlip;


import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
const ExitSlip = () => {
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const employeeid = localStorage.getItem("employee_id");
  // ⏳ Lokāl Storage se Data lena
  
 

    useEffect(() => {
    (async () => {
      try {
        // ✅ employe_id query string me send karo
        const res = await axios.get(
          `https://ims-attendanceback.indevconsultancy.in/api/exit-slip/?employe_id=${employeeid}`
        );

        setData(res.data);
        console.log("res.data", res.data);
      } catch (error) {
        console.error("Error:", error);
      }
    })();
  }, [])


  return (
    <div className="min-vh-100 d-flex align-items-center justify-content-center bg-cream">
      <div className="container my-5">
        <div className="card shadow text-center">
          <h4 className="card-header fs-3 fw-semibold bg-skyBlue text-white">
            प्रस्थान की पुष्टि
          </h4>

          <div className="card-body bg-pink">
            {/* नाम और समय */}
            <div className="mb-4">
              <h5>
                <strong>नाम:</strong> {data?.employee_name}
              </h5>
              <h6 className="text-muted">
                <strong>प्रस्थान का समय:</strong> {data?.exit_time}
              </h6>
            </div>

            {/* यूज़र की छवि */}
            <div className="d-flex justify-content-center gap-3">
            <div className="mb-4">
              {data?.exitimage ? (
                <img
                  src={data?.exitimage}
                  alt="प्रयोक्ता छवि"
                  className="rounded-circle shadow"
                  style={{
                    width: "200px",
                    height: "200px",
                    objectFit: "cover",
                    border: "3px solid #c21858",
                  }}
                />
              ) : (
                <div className="text-danger fw-semibold">
                  कोई छवि उपलब्ध नहीं है
                </div>
              )}
            </div>

            <div className="mb-4">
              {data?.profileimg ? (
                <img
                  src={data?.profileimg}
                  alt="प्रयोक्ता छवि"
                  className="rounded-circle shadow"
                  style={{
                    width: "200px",
                    height: "200px",
                    objectFit: "cover",
                    border: "3px solid #c21858",
                  }}
                />
              ) : (
                <div className="text-danger fw-semibold">
                  कोई छवि उपलब्ध नहीं है
                </div>
              )}
            </div>
            </div>
            {/* जीपीएस स्थान */}
            <div className="d-flex justify-content-around mb-4">
              <div>
                <strong>जीपीएस:</strong> {data?.latitude}°N, {data?.longitude}°E
              </div>
            </div>

            {/* OK बटन */}
            <div>
              <button
                className="btn btn-primary px-4 fw-semibold"
                onClick={() => navigate("/kitchen")}
              >
                ठीक है
              </button>
            </div>
          </div>

          <div className="card-footer text-muted small">तकनीकी साझेदार: Indev Consultancy ©2025</div>
        </div>
      </div>
    </div>
  );
};

export default ExitSlip;

